import React, { FC } from 'react'
import { cn } from '../../../../shared/utils'
import styles from '../../Story.module.scss'

type TCommentPreviewProps = {
  author: string
  date: string
  text: string
  zone: string
  actions?: React.ReactNode
}

export const CommentPreview: FC<TCommentPreviewProps> = (props) => {
  const { author, date, text, zone, actions } = props
  return (
    <div className={cn(styles.comment)}>
      <div className={styles.commentHeader}>
        <div className={styles.commentTitle}>
          <b>{zone}</b>
          <span className={styles.commentMeta}>{date} | {author}</span>
        </div>
        <div className={styles.commentActions} data-edit-mode>
          {actions}
        </div>
      </div>
      <div className={styles.commentBody}>{text}</div>
    </div>
  )
}

